import React from 'react'

export const UploadFileSvg = (props: any) => {
  return (
    <svg
      width="130"
      height="81"
      viewBox="0 0 130 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1871:268812)">
        <path
          opacity="0.13"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.0742 15.8941C27.4002 11.7021 28.6342 9.09207 29.7742 8.06307C32.9312 5.21507 37.2962 6.76507 38.2242 6.98707C41.4842 7.76907 40.4242 2.62307 43.2212 1.57707C45.0852 0.880069 46.6182 1.73207 47.8212 4.13307C48.8862 1.89307 50.5092 0.86707 52.6902 1.05007C55.9622 1.32707 57.1072 12.3781 61.6032 9.95907C66.1002 7.53907 71.6132 6.98607 73.9682 10.5821C74.4772 11.3601 74.6722 10.1531 78.1342 6.03207C81.5962 1.91007 85.0482 0.0940694 92.1302 2.49407C95.3502 3.58407 97.9982 6.53907 100.077 11.3581C100.077 18.2361 105.137 22.3081 115.255 23.5711C130.434 25.4661 118.652 41.7851 100.077 46.5641C81.5012 51.3441 38.7342 53.9241 15.5262 41.8481C0.0541611 33.7991 3.57016 25.1471 26.0732 15.8941H26.0742Z"
          fill="url(#paint0_linear_1871:268812)"
        />
        <path
          opacity="0.8"
          d="M64.134 76.6738C79.5908 76.6738 92.121 73.7735 92.121 70.1958C92.121 66.6181 79.5908 63.7178 64.134 63.7178C48.6772 63.7178 36.147 66.6181 36.147 70.1958C36.147 73.7735 48.6772 76.6738 64.134 76.6738Z"
          fill="#DEDEDE"
          fill-opacity="0.46"
        />
        <path
          opacity="0.13"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M111.384 78.2788C90.341 83.5568 18.514 77.5198 10.869 74.7628C7.14801 73.4198 3.79401 70.8947 0.808008 67.1867C0.473808 66.7721 0.263743 66.2714 0.202086 65.7425C0.140429 65.2135 0.229697 64.6779 0.459575 64.1976C0.689453 63.7172 1.05056 63.3117 1.50116 63.0279C1.95177 62.7441 2.47348 62.5936 3.00601 62.5938H128.52C131.125 69.5318 125.413 74.7598 111.384 78.2788Z"
          fill="url(#paint1_linear_1871:268812)"
        />
        <path
          d="M85.6099 52.8352L76.0389 41.6432C75.8125 41.3762 75.5312 41.1611 75.2142 41.0127C74.8972 40.8643 74.5519 40.786 74.2019 40.7832H53.6219C52.9159 40.7832 52.2449 41.1072 51.7849 41.6432L42.2139 52.8352V58.9792H85.6099V52.8352Z"
          fill="white"
        />
        <path
          d="M85.6099 52.8352L76.0389 41.6432C75.8125 41.3762 75.5312 41.1611 75.2142 41.0127C74.8972 40.8643 74.5519 40.786 74.2019 40.7832H53.6219C52.9159 40.7832 52.2449 41.1072 51.7849 41.6432L42.2139 52.8352V58.9792H85.6099V52.8352Z"
          fill="#3E4685"
        />
        <path
          d="M82.8978 59.2055L74.5208 49.4575C74.3183 49.2273 74.0686 49.0435 73.7887 48.9184C73.5089 48.7933 73.2053 48.7299 72.8988 48.7325H54.9248C54.3078 48.7325 53.7048 48.9885 53.3028 49.4575L44.9258 59.2055V64.5595H82.8978V59.2055Z"
          fill="#D1DCF2"
        />
        <path
          d="M85.6099 66.0203C85.6099 66.8733 85.2259 67.6403 84.6199 68.1543L84.4969 68.2543C84.0164 68.6185 83.4298 68.8152 82.8269 68.8143H44.9979C44.6559 68.8143 44.3289 68.7523 44.0269 68.6383L43.8769 68.5783C43.382 68.3582 42.9615 67.9993 42.6664 67.5451C42.3713 67.091 42.2141 66.561 42.2139 66.0193V52.9023H52.7429C53.9059 52.9023 54.8429 53.8593 54.8429 55.0203V55.0353C54.8429 56.1973 55.7909 57.1343 56.9539 57.1343H70.8699C71.4289 57.1338 71.9649 56.9118 72.3606 56.5169C72.7562 56.122 72.9793 55.5864 72.9809 55.0273C72.9809 53.8613 73.9189 52.9023 75.0809 52.9023H85.6109L85.6099 66.0203Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M85.6099 66.0203C85.6099 66.8733 85.2259 67.6403 84.6199 68.1543L84.4969 68.2543C84.0164 68.6185 83.4298 68.8152 82.8269 68.8143H44.9979C44.6559 68.8143 44.3289 68.7523 44.0269 68.6383L43.8769 68.5783C43.382 68.3582 42.9615 67.9993 42.6664 67.5451C42.3713 67.091 42.2141 66.561 42.2139 66.0193V52.9023H52.7429C53.9059 52.9023 54.8429 53.8593 54.8429 55.0203V55.0353C54.8429 56.1973 55.7909 57.1343 56.9539 57.1343H70.8699C71.4289 57.1338 71.9649 56.9118 72.3606 56.5169C72.7562 56.122 72.9793 55.5864 72.9809 55.0273C72.9809 53.8613 73.9189 52.9023 75.0809 52.9023H85.6109L85.6099 66.0203Z"
          fill="#3E4685"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1871:268812"
          x1="64.1381"
          y1="1.0293"
          x2="64.1381"
          y2="50.5529"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#9299BE" />
          <stop offset="1" stop-color="#3E4685" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1871:268812"
          x1="64.6575"
          y1="62.5938"
          x2="64.6575"
          y2="80.3721"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#9299BE" />
          <stop offset="1" stop-color="#3E4685" />
        </linearGradient>
        <clipPath id="clip0_1871:268812">
          <rect
            width="130"
            height="80"
            fill="white"
            transform="translate(0 0.666016)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
